export default __webpack_public_path__ + "static/media/unknown.ff3973d9.svg";